import PropTypes from "prop-types";
import React from "react";
import "./RotationDisplay.css";

export default function RotationDisplay({angle, label, imgSrc}) {
  return (
    <>
      <div className="rotation-display">
        <div className="rotation-content">
          <img
              className="rotation-img"
              alt={`${'label'} display`}
              src={imgSrc}
              style={{transform: `rotate(${angle}deg)`}}
            />
          <div className="angleValue">{angle.toFixed(2)}°</div>
          <div className="label">{label}</div>
        </div>
      </div>
    </>
  );
}

RotationDisplay.propTypes = {
  angle: PropTypes.number.isRequired,
};